import React, { Component } from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import Modal from "react-responsive-modal";
import axios from "axios";
import Spinner from "react-spinkit";
import Slider from "react-slick";
import Lightbox from "react-images";
import mergeImages from "merge-images";
import resizebase64 from "resize-base64";
//import ShareButton from "react-social-share-buttons";
import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  RedditShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  //ViberShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  WhatsappIcon,
  GooglePlusIcon,
  LinkedinIcon,
  PinterestIcon,
  RedditIcon,
  TumblrIcon,
  LivejournalIcon,
  VKIcon,
  OKIcon,
  MailruIcon,
  MailruShareButton,
  EmailIcon
} from "react-share";

var image_index = 0;

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  image_index = props.currentSlide;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img
        src={require("../assets/right.png")}
        alt="next"
        style={{ marginTop: "-25px" }}
      />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  image_index = props.currentSlide;
  return (
    <div
      className={className}
      style={{
        ...style
      }}
      onClick={onClick}
    >
      <img
        src={require("../assets/left.png")}
        alt="previous"
        style={{ marginTop: "-25px" }}
      />
    </div>
  );
}

function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

function convertURIToImageData(URI) {
  return new Promise(function(resolve, reject) {
    if (URI == null) return reject();
    var canvas = document.createElement("canvas"),
      context = canvas.getContext("2d"),
      image = new Image();
    image.addEventListener(
      "load",
      function() {
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(context.getImageData(0, 0, canvas.width, canvas.height));
      },
      false
    );
    image.src = URI;
  });
}

// function resizedataURL(datas, wantedWidth, wantedHeight) {
//   // We create an image to receive the Data URI
//   var img = document.createElement("img");
//
//   // When the event "onload" is triggered we can resize the image.
//   img.onload = function() {
//     // We create a canvas and get its context.
//     var canvas = document.createElement("canvas");
//     var ctx = canvas.getContext("2d");
//
//     // We set the dimensions at the wanted size.
//     canvas.width = wantedWidth;
//     canvas.height = wantedHeight;
//
//     // We resize the image with the canvas method drawImage();
//     ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
//
//     var dataURI = canvas.toDataURL();
//
//     /////////////////////////////////////////
//     // Use and treat your Data URI here !! //
//     /////////////////////////////////////////
//   };
//
//   // We put the Data URI in the image's src attribute
//   img.src = datas;
// }

var settings = {
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  speed: 500,
  autoplaySpeed: 10000,
  cssEase: "linear",
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

class Upload extends Component {
  constructor() {
    super();
    this.state = {
      files: [],
      open: false,
      modalTitle: "",
      modalText: "",
      loading: false,
      processing: false,
      result: [],
      result_error: false,
      lightbox: [],
      shareUrl: "",
      showShare: false
    };
  }

  onOpenModal = (modalTitle, modalText) => {
    this.setState({
      open: true,
      modalTitle: modalTitle,
      modalText: modalText,
      result_error: false
    });
  };

  mergeImg = (img1_url, img2_url) => {
    this.setState({ loading: true });
    var img1;
    var img1_width;
    var img1_height;
    var img1_new_width;
    var img1_new_height;
    var img2;
    var img3;
    var img2_width;
    var img2_height;
    var img2_new_width;
    var img2_new_height;

    toDataURL(img1_url, dataUrl => {
      img1 = dataUrl;
      convertURIToImageData(img1).then(imageData => {
        img1_width = imageData.width;
        img1_height = imageData.height;
        img1_new_width = 400;
        img1_new_height = img1_height * 400 / img1_width;

        toDataURL(img2_url, dataUrl2 => {
          img2 = dataUrl2;
          convertURIToImageData(img2).then(imageData2 => {
            img2_width = imageData2.width;
            img2_height = imageData2.height;
            img2_new_width = img1_new_height * img2_width / img2_height;
            img2_new_height = img1_new_height;

            toDataURL(require("../assets/lk.png"), dataUrl3 => {
              img3 = dataUrl3;
              convertURIToImageData(img3).then(imageData3 => {
                mergeImages(
                  [
                    {
                      src: resizebase64(img1, img1_new_width, img1_new_height)
                    },
                    {
                      src: resizebase64(img2, img2_new_width, img2_new_height),
                      x: img1_new_width
                    },
                    {
                      src: resizebase64(img3, 227, 40),
                      x: img1_new_width + img2_new_width - 237,
                      y: img2_new_height - 50
                    }
                  ],
                  {
                    width: img1_new_width + img2_new_width,
                    height: img2_new_height
                  }
                ).then(b64 => {
                  //console.log(b64);
                  axios({
                    url: "/merge",
                    method: "post",
                    data: { base64: b64, id: this.props.auth.googleId }
                  })
                    .then(response => {
                      // your action after success
                      console.log(response.data.res);
                      this.setState({
                        shareUrl: response.data.res,
                        loading: false,
                        showShare: true
                      });
                    })
                    .catch(error => {
                      // your action on error success
                      console.log(error);
                      this.setState({
                        shareUrl: "",
                        loading: false
                      });
                    });
                });
              });
            });
          });
        });
      });
    });
  };

  onCloseModal = () => {
    this.setState({ open: false, files: [], result: [] });
  };

  onCloseSharing = () => {
    this.setState({ showShare: false });
  };

  getData() {
    this.setState({ loading: true, processing: true });
    var url = new Buffer(this.state.files[0]).toString("base64");

    axios
      .post("/get_data", {
        url: url,
        id: this.props.auth.googleId
      })
      .then(response => {
        //console.log(response);
        var lightbox_array = [];
        for (var i = 0; i < response.data.length; i++) {
          lightbox_array.push(false);
        }
        this.setState({
          loading: false,
          processing: false,
          result: response.data,
          lightbox: lightbox_array
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false, processing: false, result: "Error" });
      });
  }

  shareMerge() {
    this.mergeImg(this.state.files[0], this.state.result[image_index][3]);
  }

  onDrop = acceptedFiles => {
    if (acceptedFiles.length === 1) {
      this.setState({ loading: true });
      axios
        .post("/check", {
          id: this.props.auth.googleId
        })
        .then(response => {
          if (response.data.res === "Forbidden user") {
            this.setState({ loading: false });
            this.onOpenModal("Forbidden User", "You must be logged in.");
          } else if (response.data.res === "No credits") {
            this.setState({ loading: false });
            this.onOpenModal(
              "You reached the limit",
              "Please wait one hour to find doppelgangers again."
            );
          } else if (response.data.res === "1") {
            const uploaders = acceptedFiles.map(file => {
              const data = new FormData();
              data.append("file", file);
              // '/files' is your node.js route that triggers our middleware
              return axios.post("/upload", data).then(response => {
                const data = response.data;
                const fileURL = data.fileURL; // You should store this URL for future references in your app
                //console.log(fileURL);
                var file_array = this.state.files;
                file_array.push(fileURL);
                this.setState({
                  files: file_array
                });
              });
            });
            // Once all the files are uploaded
            axios.all(uploaders).then(() => {
              // ... perform after upload is successful operation
              //console.log("all done");
              this.setState({ loading: false });
            });
          } else {
            this.setState({ loading: false });
            this.onOpenModal("Unknown error", "Please try again later.");
          }
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false, processing: false, result: "Error" });
        });
    } else {
      this.onOpenModal(
        "Upload one photo",
        "You must upload just one photo to find doppelgangers based on that photo."
      );
    }
  };

  renderLevel(level) {
    if (level < 0.34) {
      return (
        <img
          src={require("../assets/high.png")}
          width="40px"
          height="20px"
          alt="High"
          style={{
            display: "inline-block",
            verticalAlign: "middle"
          }}
        />
      );
    } else if (level >= 0.34 && level <= 0.49) {
      return (
        <img
          src={require("../assets/med.png")}
          width="40px"
          height="20px"
          alt="Medium"
          style={{
            display: "inline-block",
            verticalAlign: "middle"
          }}
        />
      );
    } else {
      return (
        <img
          src={require("../assets/low.png")}
          width="40px"
          height="20px"
          alt="Low"
          style={{
            display: "inline-block",
            verticalAlign: "middle"
          }}
        />
      );
    }
  }

  renderContent() {
    //console.log(this.state.result);
    switch (this.props.auth) {
      case null:
        return;
      case false:
        return (
          <div
            style={{
              height: "500px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <center>
              <h5>You must be logged in to upload images</h5>
              <br />
              <a href="/auth/google">
                <img
                  src={require("../assets/login-google.png")}
                  alt="Login Google"
                  width="200px"
                />
              </a>
            </center>
          </div>
        );
      default:
        let modal_view = null;
        if (this.state.open && this.state.loading === false) {
          modal_view = (
            <div>
              <Modal open={true} onClose={this.onCloseModal} center>
                <h5>
                  <p>{this.state.modalTitle}</p>
                </h5>
                <h6>
                  <p>{this.state.modalText}</p>
                </h6>
              </Modal>
            </div>
          );
        }

        let shareUrl = "https://lookaliker.com/couple/" + this.state.shareUrl;
        let title = "Look at these doppelgangers!";
        let share_view = (
          <div className="share_container">
            <div className="share_some-network">
              <FacebookShareButton
                url={shareUrl}
                quote={title}
                className="share_some-network__share-button"
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
            </div>

            <div className="share_some-network">
              <TwitterShareButton
                url={shareUrl}
                title={title}
                className="share_some-network__share-button"
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
            </div>

            <div className="share_some-network">
              <TelegramShareButton
                url={shareUrl}
                title={title}
                className="share_some-network__share-button"
              >
                <TelegramIcon size={32} round />
              </TelegramShareButton>
            </div>

            <div className="share_some-network">
              <WhatsappShareButton
                url={shareUrl}
                title={title}
                separator=":: "
                className="share_some-network__share-button"
              >
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </div>

            <div className="share_some-network">
              <GooglePlusShareButton
                url={shareUrl}
                className="share_some-network__share-button"
              >
                <GooglePlusIcon size={32} round />
              </GooglePlusShareButton>
            </div>

            <div className="share_some-network">
              <LinkedinShareButton
                url={shareUrl}
                title={title}
                windowWidth={750}
                windowHeight={600}
                className="share_some-network__share-button"
              >
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
            </div>

            <div className="share_some-network">
              <PinterestShareButton
                media={shareUrl}
                url={shareUrl}
                title={title}
                description={shareUrl}
                className="share_some-network__share-button"
              >
                <PinterestIcon size={32} round />
              </PinterestShareButton>
            </div>

            <div className="share_some-network">
              <RedditShareButton
                url={shareUrl}
                title={title}
                windowWidth={660}
                windowHeight={460}
                className="share_some-network__share-button"
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
            </div>

            <div className="share_some-network">
              <TumblrShareButton
                url={shareUrl}
                title={title}
                windowWidth={660}
                windowHeight={460}
                className="share_some-network__share-button"
              >
                <TumblrIcon size={32} round />
              </TumblrShareButton>
            </div>

            <div className="share_some-network">
              <LivejournalShareButton
                url={shareUrl}
                title={title}
                description={shareUrl}
                className="share_some-network__share-button"
              >
                <LivejournalIcon size={32} round />
              </LivejournalShareButton>
            </div>

            <div className="share_some-network">
              <VKShareButton
                url={shareUrl}
                title={title}
                description={shareUrl}
                className="share_some-network__share-button"
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </div>

            <div className="share_some-network">
              <OKShareButton
                url={shareUrl}
                title={title}
                description={shareUrl}
                className="share_some-network__share-button"
              >
                <OKIcon size={32} round />
              </OKShareButton>
            </div>

            <div className="share_some-network">
              <MailruShareButton
                url={shareUrl}
                title={title}
                className="share_some-network__share-button"
              >
                <MailruIcon size={32} round />
              </MailruShareButton>
            </div>

            <div className="share_some-network">
              <EmailShareButton
                url={shareUrl}
                subject={title}
                body="body"
                className="share_some-network__share-button"
              >
                <EmailIcon size={32} round />
              </EmailShareButton>
            </div>
          </div>
        );

        if (this.state.showShare && this.state.loading === false) {
          console.log("Sharing view");
          modal_view = (
            <div>
              <Modal open={true} onClose={this.onCloseSharing} center>
                <p>
                  <h5>Share in:</h5>
                </p>
                {share_view}
              </Modal>
            </div>
          );
        }
        let drop_view = null;
        let subtitle_view = null;
        if (this.state.files.length !== 1 && this.state.loading === false) {
          subtitle_view = (
            <div>
              <h5>
                <p>
                  <font color="#689BDF">Upload your photos</font>
                </p>
              </h5>
              <h6>
                <p>
                  <font color="#689BDF">
                    You can upload multiple images and the accuracy could be
                    better
                  </font>
                </p>
              </h6>
            </div>
          );

          drop_view = (
            <div className="dropzone" style={{ margin: "50px" }}>
              <Dropzone
                accept="image/jpeg, image/png"
                //onDrop={this.handleDrop}
                onDrop={this.onDrop}
                multiple
                style={{
                  width: "100%",
                  height: "300px",
                  border: "2px dashed #999999",
                  borderColor: "#999999",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <center>
                    <h5>
                      <p>
                        <font color="#999999">Drop your photo here</font>
                      </p>
                    </h5>
                    <br />
                    <h6>
                      <p>
                        <font color="#999999">
                          Only *.jpeg and *.png images will be accepted
                        </font>
                      </p>
                    </h6>
                  </center>
                </div>
              </Dropzone>
            </div>
          );
        }
        let image_view = null;

        let share_button_view = null;
        if (this.state.loading === false && this.state.result.length < 1) {
          image_view = (
            <aside>
              <font color="#689BDF">
                <h5>{this.state.files.length > 0 ? "Dropped photo" : ""}</h5>
              </font>
              <center>
                <ul>
                  {this.state.files.map((f, index) => (
                    <li
                      key={f}
                      style={{ display: "inline-block", margin: "10px" }}
                    >
                      <img
                        src={f}
                        alt={index}
                        width="400px"
                        style={{ display: "inline-block" }}
                      />
                    </li>
                  ))}
                </ul>
              </center>
              {this.state.files.length > 0 ? (
                <center>
                  <p>
                    <a
                      className="waves-effect waves-light btn red"
                      onClick={() => this.setState({ files: [] })}
                    >
                      Cancel
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="waves-effect waves-light btn blue"
                      onClick={() => this.getData()}
                    >
                      Next
                    </a>
                  </p>
                </center>
              ) : (
                ""
              )}
            </aside>
          );
        } else if (
          this.state.loading === false &&
          this.state.result.length > 0 &&
          this.state.result !== "More" &&
          this.state.result !== "Error"
        ) {
          //console.log(this.state.files[0]);
          //console.log(this.state.result[0][3]);
          //this.mergeImg(this.state.files[0], this.state.result[0][3]);
          image_view = (
            <div>
              <font color="#689BDF">
                <h5>{this.state.files.length > 0 ? "Result" : ""}</h5>
              </font>
              <div
              // style={{
              //   display: "flex",
              //   flexDirection: "row",
              //   justifyContent: "center",
              //   alignItems: "center"
              // }}
              >
                <div
                  style={{
                    display: "inline-block",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    alignSelf: "flex-start"
                  }}
                >
                  <div
                    style={{
                      display: "inline-block",
                      justifyContent: "center",
                      alignItems: "center",
                      alignSelf: "center",
                      marginRight: 50
                    }}
                  >
                    <div
                      className="vCenterItems"
                      style={{
                        width: "400px",
                        display: "block"
                      }}
                    >
                      <ul>
                        {this.state.files.map((f, index) => {
                          return (
                            <li key={f}>
                              <img
                                src={f}
                                alt={index}
                                width="400px"
                                style={{ display: "inline-block" }}
                              />
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "inline-block",
                      justifyContent: "center",
                      alignItems: "center",
                      alignSelf: "center"
                    }}
                  >
                    <div
                      className="vCenterItems"
                      style={{
                        width: "400px",
                        display: "block"
                      }}
                    >
                      <center>
                        <Slider {...settings} width="400px">
                          {this.state.result.map((f, index) => {
                            var image = f[3];
                            var res = image.split("/");
                            var filename = res[res.length - 1];
                            var path = image.replace(filename, "");
                            var full_thumb_path = path + "thumb-" + filename;
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "inline-block",
                                  margin: "10px"
                                }}
                              >
                                <div>
                                  <img
                                    src={full_thumb_path}
                                    alt={index}
                                    width="300px"
                                    style={{ display: "inline-block" }}
                                    onClick={() => {
                                      const items = this.state.lightbox;
                                      items[index] = true;
                                      this.setState({
                                        lightbox: items
                                      });
                                    }}
                                  />
                                  <Lightbox
                                    images={[
                                      {
                                        src: image,
                                        caption: "Image from Wikipedia"
                                      }
                                    ]}
                                    isOpen={this.state.lightbox[index]}
                                    onClickImage={index => {
                                      var lightbox_array = [];
                                      for (
                                        var i = 0;
                                        i < this.state.lightbox.length;
                                        i++
                                      ) {
                                        lightbox_array.push(false);
                                      }
                                      this.setState({
                                        lightbox: lightbox_array
                                      });
                                    }}
                                    onClose={index => {
                                      var lightbox_array = [];
                                      for (
                                        var i = 0;
                                        i < this.state.lightbox.length;
                                        i++
                                      ) {
                                        lightbox_array.push(false);
                                      }
                                      this.setState({
                                        lightbox: lightbox_array
                                      });
                                    }}
                                    showImageCount={false}
                                  />
                                </div>
                                <div>
                                  <center>
                                    <h6>
                                      <b>
                                        {f[0]} {f[1]}
                                      </b>
                                    </h6>
                                  </center>
                                </div>
                                <div>
                                  <center>
                                    <h6>
                                      <div>
                                        <span
                                          style={{
                                            verticalAlign: "middle"
                                          }}
                                        >
                                          Similarity Level:
                                        </span>
                                        {"  "}
                                        {/*((1 - f[5]) * 100).toFixed(2)*/}
                                        {this.renderLevel(f[5])}
                                      </div>
                                    </h6>
                                  </center>
                                </div>
                                <div>
                                  <center>
                                    <h6>
                                      More info:{" "}
                                      <a href={f[2]} target="_blank">
                                        Wikipedia
                                      </a>
                                    </h6>
                                  </center>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      </center>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );

          // share_view = (
          //   <div
          //     className="share_container"
          //     style={{
          //       display: "flex",
          //       flexDirection: "row",
          //       justifyContent: "center"
          //     }}
          //   >
          //     <ShareButton
          //       compact
          //       socialMedia={"facebook"}
          //       url={shareUrl}
          //       media={"https://imgs.xkcd.com/comics/error_code.png"}
          //       text={title}
          //     />
          //     <ShareButton
          //       compact
          //       socialMedia={"twitter"}
          //       //url={shareUrl}
          //       url={
          //         "http://res.cloudinary.com/lookaliker/image/upload/v1525872294/z34aaaykswcqkbrjhhbu.jpg"
          //       }
          //       text={title}
          //     />
          //     <ShareButton
          //       compact
          //       socialMedia={"google-plus"}
          //       url={shareUrl}
          //       media={"https://imgs.xkcd.com/comics/error_code.png"}
          //       text={title}
          //     />
          //     <ShareButton
          //       compact
          //       socialMedia={"pinterest"}
          //       url={shareUrl}
          //       media={"https://imgs.xkcd.com/comics/error_code.png"}
          //       text={title}
          //     />
          //   </div>
          // );

          share_button_view = (
            <div>
              <br />
              <center>
                <a
                  className="waves-effect waves-light btn purple darken-2"
                  onClick={() => this.shareMerge()}
                >
                  Share
                </a>
              </center>
            </div>
          );
        } else if (
          this.state.loading === false &&
          this.state.result.length > 0 &&
          this.state.result === "More"
        ) {
          if (this.state.result_error === false) {
            this.onOpenModal("No result", "Try again with another photo.");
            this.setState({ result_error: true });
          }
        } else if (
          this.state.loading === false &&
          this.state.result.length > 0 &&
          this.state.result === "Error"
        ) {
          if (this.state.result_error === false) {
            this.onOpenModal("Error", "There is an error, try again later.");
            this.setState({ result_error: true, result: [] });
          }
        } else {
          if (this.state.processing) {
            image_view = (
              <div
                style={{
                  display: "flex",
                  height: "500px",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column"
                  }}
                >
                  <center>
                    <Spinner
                      fadeIn="none"
                      name="line-scale-pulse-out"
                      color="#689BDF"
                    />
                  </center>

                  <h6>
                    <center>
                      <p>
                        <font color="#689BDF">Processing...</font>
                      </p>
                    </center>
                  </h6>
                </div>
              </div>
            );
          } else {
            image_view = (
              <div
                style={{
                  display: "flex",
                  height: "500px",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column"
                  }}
                >
                  <center>
                    <Spinner
                      fadeIn="none"
                      name="line-scale-pulse-out"
                      color="#689BDF"
                    />
                  </center>

                  <h6>
                    <center>
                      <p>
                        <font color="#689BDF">Loading...</font>
                      </p>
                    </center>
                  </h6>
                </div>
              </div>
            );
          }
        }

        return (
          <div style={{ marginTop: "20px" }}>
            {subtitle_view}
            <section>
              {drop_view}
              {modal_view}
              {image_view}
              {/*share_view*/}
              {share_button_view}
            </section>
          </div>
        );
    }
  }

  render() {
    return <div>{this.renderContent()}</div>;
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Upload);



// WEBPACK FOOTER //
// ./src/components/Upload.js